import { CurrentPricingPlan } from 'common/hooks/useCurrentPricingPlan';
import { toMajorUnits } from 'helpers/amount';

import { VirtualOrderFlowConfig } from './hooks/useVirtualCardOrderFlowContext';
import { VirtualCardOrderFlowQuery } from './hooks/virtualCardOrderFlow.gql';

export function mapQueryResultToFlowConfig(
  data: VirtualCardOrderFlowQuery,
  pricingPlan: CurrentPricingPlan,
): VirtualOrderFlowConfig {
  const {
    newVirtualCardPrice: { priceWithoutVAT },
    viewer: {
      company: { bankAccount, companyProfileId },
    },
    virtualCardPriceAfterQuotaReached: {
      priceWithoutVAT: priceAfterQuotaReachedWithoutVAT,
    },
    virtualCardQuotas: { limit, used },
  } = data;

  if (!bankAccount) {
    throw new Error(
      `No bankAccount in mapQueryResultToFlowConfig for company ${companyProfileId}`,
    );
  }

  const brandName = `Shine ${pricingPlan.brandName}`;

  return {
    bankAccount: {
      bankAccountId: bankAccount?.bankAccountId ?? '',
      nextBalance: toMajorUnits(bankAccount?.nextBalance ?? 0),
    },
    cardType: pricingPlan.paymentCard.type,
    formattedPlanName: brandName,
    freeCardsIncluded: limit,
    freeCardsLeft: limit - used,
    priceAfterQuotaReachedWithoutVAT,
    priceWithoutVAT,
  };
}
